export default "__VITE_ASSET__9a990f49__"